export default __webpack_public_path__ + "static/form-bg-502e60864dacd85a73d090d232143164.svg";